"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceIdToDataSource = void 0;
//Add different datasources here
//1. If field type is Number  - not necessary to have domain values
//2. If field type is Text we need to have two domain values(index 0 is considered successValue and 1 is failureValue -
// until we introduce drop down to select success and failure value)
exports.DataSourceIdToDataSource = new Map([
    [
        '0FbB0000000IJgPKAW',
        {
            id: '0FbB0000000IJgPKAW',
            version: '0FcB0000004WwM3KAK',
            fields: [
                { name: 'AWND', type: 'Number', domain: [] },
                { name: 'PRCP', type: 'Number', domain: [] },
                { name: 'TMAX', type: 'Number', domain: [] },
            ],
        },
    ],
    [
        '0FbB000000043YZKAY',
        { id: '0FbB000000043YZKAY', version: '0FcB0000005YbDfKAK', fields: [{ name: 'gender', type: 'Text', domain: ['M', 'F'] }] },
    ],
]);
//# sourceMappingURL=PredictiveModel.js.map